import { Element, Component, Host, h, Prop } from '@stencil/core';
import { projectTemplate } from '../../utils/utils';
import { RenderedWidget } from '../../entities';

@Component({
  tag: 'me-widget-placement',
  shadow: false,
  styleUrl: 'me-widget-placement.scss',
})
export class MeWidgetPlacement {
  @Element() host: HTMLMeWidgetPlacementElement;

  @Prop() widget?: RenderedWidget = null;

  get isLoading(): boolean {
    return this.widget === null;
  }

  render() {
    const classList = [
      'me-widget-placement',
      this.isLoading ? 'me-widget-placement--loading' : null,
      this.isAboveTheFold()
        ? 'me-widget-placement--above-the-fold'
        : 'me-widget-placement--below-the-fold',
    ]
      .filter(c => !!c)
      .join(' ');

    const template = document.createElement('template');

    if (this.widget) {
      template.innerHTML = this.widget.html ?? '';
    }

    return (
      <Host class={classList}>
        <div
          class="me-widget-placement__content"
          ref={projectTemplate(template)}
        />
      </Host>
    );
  }

  /**
   * Returns whether this element is considered to be above the fold.
   *
   * @param offset The offset may account for possible layout shifts introduced by other elements
   */
  private isAboveTheFold(offset = 250) {
    const viewportHeight = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0,
    );
    const yPosition = scrollY + this.host.getBoundingClientRect().top;
    return viewportHeight + offset >= yPosition;
  }
}
